import {InputNumber} from 'primereact/inputnumber'
import {Slider} from 'primereact/slider'
import {
    forwardRef,
    useCallback,
    useImperativeHandle,
    useRef,
    useState,
} from 'react'
import {getObsColors} from '../observations/Constants'
import {getIndexOfValueInMultiCol} from '../observations/Utils'
const SliderUtils = forwardRef(
    (
        {
            min = 0,
            max = 0,
            step = 1,
            labelValue = '',
            defaultValue = 0,
            placeholder = '',
            observation = false,
            colors,
            onChangeKey = '',
            dataRange,
            state = false,
            minFractionDigits = 0,
            maxFractionDigits = 0,
            onChangeValue = () => {},
            borderNoRoundLeft = false,
            maxLength = null,
        },
        ref,
    ) => {
        useImperativeHandle(ref, () => ({
            value: value > min ? value : null,
            onChange: handleChangeValue,
        }))

        const handleChangeValue = useCallback(data => {
            setValue(data)
        }, [])

        const sliderRefs = useRef(null)

        const [value, setValue] = useState(defaultValue ? defaultValue : min)

        const getColorByValue = (
            colorList,
            dataRange,
            value,
            isNews = false,
        ) => {
            if (
                !colorList ||
                !Array.isArray(colorList) ||
                !dataRange ||
                !Array.isArray(dataRange) ||
                !value
            ) {
                return ''
            }
            const obsColors = getObsColors()
            if (!isNews) {
                if (obsColors && obsColors.lv1 && obsColors.lv4) {
                    colorList = colorList.map(x => {
                        return x === obsColors.lv1
                            ? '#44cc61'
                            : x === obsColors.lv4
                            ? '#cd5c5c'
                            : x
                    })
                }
                const headColor = colorList[0]
                const tailColor = colorList[colorList.length - 1]

                colorList.push(tailColor)
                colorList.unshift(headColor)
            }

            let colorValue = ''
            let colorIndex = getIndexOfValueInMultiCol(dataRange, value)
            if (colorIndex !== null) {
                if (!isNews) {
                    colorValue = colorList[colorIndex + 1]
                } else {
                    colorValue = colorList[colorIndex]
                }
            }

            return colorValue
        }

        const handleOnChange = useCallback(
            e => {
                setValue(e.value)

                if (!!state) {
                    onChangeValue(e.value)
                }
                if (!!observation) {
                    onChangeValue(onChangeKey, e.value > min ? e.value : min)
                }
            },
            [observation, onChangeKey, state, onChangeValue, min],
        )

        const getFractionDigits = steps => {
            switch (steps) {
                default:
                    return 0
                case 0.1:
                    return 1
                case 0.01:
                    return 2
            }
        }

        return (
            <div className="col-12 p-0">
                <InputNumber
                    id={value && dataRange ? 'changeColor' : ''}
                    className={`col-12 px-0 m-0 mb-0 ${
                        borderNoRoundLeft && 'border-noround-right'
                    }`}
                    inputClassName={`text-md sm:text-md md:text-xl lg:text-xl text-center lightgray  ${
                        borderNoRoundLeft && 'border-noround-right'
                    }`}
                    prefix=""
                    suffix={labelValue && ` ${labelValue}`}
                    // min={min}
                    // max={max}
                    step={step}
                    placeholder={placeholder}
                    minFractionDigits={getFractionDigits(step)}
                    maxFractionDigits={getFractionDigits(step)}
                    value={value !== min ? value : null}
                    style={{
                        '--inputColor':
                            value !== min
                                ? getColorByValue(
                                      colors,
                                      dataRange,
                                      value,
                                      false,
                                  )
                                : '#f9f9f9',
                        '--inputTextColor': ['#cd5c5c', '#44cc61'].includes(
                            getColorByValue(colors, dataRange, value, false),
                        )
                            ? 'white'
                            : 'black',
                    }}
                    // onValueChange={handleOnChange}
                    onChange={handleOnChange}
                    maxLength={maxLength}
                />
                <Slider
                    className="col-12 m-0 p-0 w-full"
                    ref={sliderRefs}
                    style={{top: '-10px'}}
                    min={min}
                    max={max}
                    step={step}
                    placeholder={placeholder}
                    value={value}
                    onChange={handleOnChange}
                />
            </div>
        )
    },
)

export default SliderUtils
